import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import schoolRepository from '@/api/repositories/schoolRepository/SchoolRepository.ts';

export const useSchools = (regionId?: string) => {
  return useQuery({
    queryKey: ['schools', regionId ?? 'all'],
    queryFn: async () => {
      const { data, error } = regionId
        ? await schoolRepository.findMany({ region_id: regionId }, { order: { by: 'created_at', ascending: true } })
        : await schoolRepository.all({ order: { by: 'created_at', ascending: true } });
      if (error) throw new Error(error.message);
      return data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateSchools = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { name: string; region_id: string }[]) => {
      const { data, error } = await schoolRepository.createMany(payload);
      if (error) throw new Error(error.message);
      if (!data || data.length !== payload.length) {
        throw new Error(`Expected ${payload.length} schools to be created, got ${data?.length ?? 0}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['schools'] });
    },
  });
};
